// Admin Help Center content registry.
//
// Each article lives in ./articles as a module exporting
// { id, title, section, order, keywords, body } where body is a markdown
// string rendered on the Help page. To add an article: create the file,
// import it here, add it to ARTICLES. Entries in PLANNED show as
// "coming soon" so the roadmap of remaining topics stays visible in-app.

import dashboard from "./articles/dashboard";
import shifts from "./articles/shifts";
import calendar from "./articles/calendar";
import messages from "./articles/messages";
import timeOff from "./articles/timeOff";
import authorizations from "./articles/authorizations";
import reports from "./articles/reports";
import timesheetBilling from "./articles/timesheetBilling";
import payments from "./articles/payments";
import quarterly from "./articles/quarterly";
import verification from "./articles/verification";
import payrollMileage from "./articles/payrollMileage";
import clients from "./articles/clients";
import caregivers from "./articles/caregivers";
import compliance from "./articles/compliance";
import settings from "./articles/settings";
import adminOrg from "./articles/adminOrg";
import cbsPrograms from "./articles/cbsPrograms";
import auditLogs from "./articles/auditLogs";

export const SECTIONS = [
  "Daily Operations",
  "Billing & Reports",
  "People",
  "Administration",
];

export const ARTICLES = [
  dashboard,
  shifts,
  calendar,
  messages,
  timeOff,
  authorizations,
  reports,
  timesheetBilling,
  payments,
  quarterly,
  verification,
  payrollMileage,
  clients,
  caregivers,
  compliance,
  settings,
  adminOrg,
  cbsPrograms,
  auditLogs,
].sort((a, b) => a.order - b.order);

// Topics not written yet — shown greyed-out so admins know they're coming
// and we remember what's left. Move each to ARTICLES as it gets written.
export const PLANNED = [];
